import React, { useEffect, useMemo, useState } from "react";
import { Flex, Box, Text, Center } from "@chakra-ui/react";
import useAuth from "../hooks/useAuth";
import { getScore } from "../data/api";

const ScoreOverview = () => {
  const [lancasterScore, setLancasterScore] = useState(10);
  const [yorkScore, setYorkScore] = useState(5);
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      getScore(token).then((score) => {
        setLancasterScore(score.lancs);
        setYorkScore(score.york);
      });
    }
  });

  const lancasterPercent = useMemo(() => {
    const total = lancasterScore + yorkScore;
    if (total === 0) return 50;
    return Math.min(Math.max((lancasterScore / total) * 100, 20), 80);
  }, [lancasterScore, yorkScore]);

  const yorkPercent = useMemo(() => {
    const total = lancasterScore + yorkScore;
    if (total === 0) return 50;
    return Math.min(Math.max((yorkScore / total) * 100, 20), 80);
  }, [lancasterScore, yorkScore]);

  return (
    <Flex w="full" mb={5}>
      <Center
        bg="red.600"
        color="white"
        h={20}
        p={3}
        w={`${lancasterPercent}%`}
        flexDirection="column"
      >
        <Text fontFamily="Graduate" fontWeight="bold">
          LANCASTER
        </Text>
        <Text fontSize="md">{lancasterScore}</Text>
      </Center>
      <Center
        bg="white"
        color="red.600"
        h={20}
        p={3}
        w={`${yorkPercent}%`}
        flexDirection="column"
      >
        <Text fontFamily="Graduate" fontWeight="bold">
          YORK
        </Text>
        <Text fontSize="md">{yorkScore}</Text>
      </Center>
    </Flex>
  );
};

export default ScoreOverview;
